export default {
    install(Vue, options) {
        Vue.filter("dateFormat", (time, options = {}, locale) => {
            return new Date(Number(time)).toLocaleDateString(
                locale || navigator.language,
                Object.assign({ year: "numeric", month: "2-digit", day: "2-digit" }, options)
            )
        })
        const nl2br = content => {
            return content.replace(/\n/g, "<br>").replace(/\r/g, "<br>")
        }
        Vue.filter("nl2br", nl2br)
        Vue.prototype.$nl2br = nl2br
    },
}
